import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { BackButtonProps } from './BackButton.types';

const LoadableBackButtonRow: ComponentType<BackButtonProps> = lazyLoadOnRender({
  loader: () => import(/* webpackChunkName: "4-feat-applayout-backbutton" */ './BackButtonRow'),
});

export default LoadableBackButtonRow;
